import { render, staticRenderFns } from "./NovelTemplate.vue?vue&type=template&id=c90b9700&scoped=true"
var script = {}
import style0 from "./NovelTemplate.vue?vue&type=style&index=0&id=c90b9700&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90b9700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c90b9700')) {
      api.createRecord('c90b9700', component.options)
    } else {
      api.reload('c90b9700', component.options)
    }
    module.hot.accept("./NovelTemplate.vue?vue&type=template&id=c90b9700&scoped=true", function () {
      api.rerender('c90b9700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/NovelTemplate.vue"
export default component.exports